import {cardConvertor} from '../utilities/cardConvertor';

const Item = ({post, type, app, handleBokmarks}: IShownAdsItemProps) => {
  return cardConvertor[type](post, app, handleBokmarks);
};

export default Item;
